<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Plan/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>